import api from '../../interceptorServices';
import { onsite_url } from '../../../config';

const commentUrl = onsite_url + 'api/onsite/presentationComment';

/* ─────────────────────────────────────────────────────────────────
   GET — fetch all comments
───────────────────────────────────────────────────────────────── */
export const getData = async () => {
  const response = await api.get(commentUrl);
  return response.data.data;
};

/* ─────────────────────────────────────────────────────────────────
   POST — three cases handled by definePost controller:
     Case 1: { id }                         → fetch single by PK
     Case 2: { presentation_uuid, field }   → fetch filtered list
     Case 3: { id: "", presentation_uuid,
               field, author, role,
               text, type }                 → create new comment
───────────────────────────────────────────────────────────────── */
export const addData = async (data) => {
  const response = await api.post(commentUrl, data);
  return response.data;
};

/* ─────────────────────────────────────────────────────────────────
   PUT — update comment by ID
   Also used to resolve a comment: { id, resolved: true }
───────────────────────────────────────────────────────────────── */
export const updateData = async (data) => {
  const response = await api.put(commentUrl, data);
  return response.data;
};

/* ─────────────────────────────────────────────────────────────────
   DELETE — delete comment by ID
───────────────────────────────────────────────────────────────── */
export const deleteData = async (data) => {
  const response = await api.delete(commentUrl, {
    data: { id: data.id },
  });
  return response.data;
};